import React, { useEffect} from 'react';
import { Col, Form, Row, Select } from 'antd';
import { Area } from '../../../../../models/JuradosModel/jurados.model';
import { UseVerConvocatorias } from "../../../../../hooks/UseVerConvocatorias";
const { Option } = Select;

type SelectCategoriaProps = {
    areas: Area[],
    handleConocimientoChange: any,
    handleAreaPrincipalChange: any
    areaPrincipal: any,
    conocimiento: any,
}


export const SelectCategoria = ({ areas, handleConocimientoChange, handleAreaPrincipalChange, areaPrincipal, conocimiento }: SelectCategoriaProps) => {

  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();

  useEffect(() => {
    getConvocatoriaPersistente();
  }, []);

    return (
        <Form layout="vertical">
            <div className="row">
                <div className="col-12 col-md-6">
                    <Form.Item label="Tipo de conocimiento" className='no-margin'>
                      {
                        !(convocatoria.nombre_convocatoria.includes('infraestructura')) && (
                          <Select placeholder="Seleccionar..." onChange={handleConocimientoChange} value={conocimiento}>
                            <Option value={'Experto con título'}>Experto con título de educación formal</Option>
                            <Option value={'Experto sin título'}>Experto sin título de educación formal</Option>
                          </Select>
                        )
                      }
                      {
                        (convocatoria.nombre_convocatoria.includes('infraestructura')) && (
                          <Select placeholder="Seleccionar..." onChange={handleConocimientoChange} value={conocimiento}>
                            <Option value={'Experto con título'}>Experto con título de educación formal</Option>
                          </Select>
                        )
                      }
                    </Form.Item>
                </div>
                <div className="col-12 col-md-6">
                        {
                          !(convocatoria.nombre_convocatoria.includes('infraestructura')) && (
                            <Form.Item label="Expresiones culturales">
                              <Select
                                  placeholder="Seleccionar..."
                                  showSearch
                                  filterOption={(input, option: any) =>
                                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                  onChange={handleAreaPrincipalChange}
                                  value={areaPrincipal}
                              >
                                  {areas.map(({ id_area, nombre_area }) =>
                                    !(
                                      nombre_area.includes('Arquitectura') ||
                                      nombre_area.includes('Museos') ||
                                      nombre_area.includes('Infraestructura artes escénica') ||
                                      nombre_area.includes('Ingenierías tecnología y cienc') ||
                                      nombre_area.includes('Altavoz') ||
                                      nombre_area.includes('Arquitectura LEP') ||
                                      nombre_area.includes('Ingeniería civil LEP') ||
                                      nombre_area.includes('Administración de empresas LEP') ||
                                      nombre_area.includes('Derecho LEP') ||
                                      nombre_area.includes('Gestión cultural LEP') ||
                                      nombre_area.includes('Diseño LEP')
                                    ) && (
                                      <Option key={id_area} value={id_area}>
                                        {nombre_area}
                                      </Option>
                                    )
                                  )}
                              </Select>
                            </Form.Item>
                          )
                        }
                        {
                          convocatoria.nombre_convocatoria.includes('infraestructura') && (
                            <Form.Item label="Áreas de conocimiento">
                              <Select
                                  placeholder="Seleccionar..."
                                  value={areaPrincipal}
                                  onChange={handleAreaPrincipalChange}
                              >
                                  {areas.map(({ id_area, nombre_area }) =>
                                    (
                                      nombre_area.includes('Ingeniería civil LEP') ||
                                      nombre_area.includes('Administración de empresas LEP') ||
                                      nombre_area.includes('Derecho LEP') ||
                                      nombre_area.includes('Gestión cultural LEP') ||
                                      nombre_area.includes('Diseño LEP')
                                    ) && (
                                      <Option key={id_area} value={id_area}>
                                        {nombre_area}
                                      </Option>
                                    )
                                  )}
                              </Select>
                            </Form.Item>
                          )
                        }
                </div>
            </div>
        </Form>
    )
}
